<template>
      <div class="reports col-md-12" style="margin-bottom: 50px;">
        <b-container>
        <b-container>
        <div class="row" style="margin-top:23px;">
            <div class="col-sm-9">
                <h4 style="color:#17a2b8;"></h4>
            </div>
            <div class="col-sm-3" style="">
                <b-form-group  v-bind:hidden="getShowEditDelete">
                <b-row class="">
                <b-button block  v-bind:hidden="getShowEditDelete" size="lg" :to="{name: 'validate'}" variant="outline-none" class="align-items-center d-flex justify-content-center" style="border-radius: unset; border: none; outline:none; font-size:17px; background-color:#91C85F; font-weight:600; color:white;">Validate Reports
                </b-button>
                </b-row>
                </b-form-group>
            </div>
        </div>
        <div class="row" style="margin-top:1px;">
            <div class="col-sm-9">
                <h4 style="color:#17a2b8;"></h4>
            </div>
            <div class="col-sm-3" style="">
                <b-form-group v-bind:hidden="getShowMyReports">
                <b-row class="">
                <b-button block v-bind:hidden="getShowMyReports" size="lg" :to="{name: 'myreports'}" variant="outline-none" class="align-items-center d-flex justify-content-center" style="border-radius: unset; border: none; outline:none; font-size:17px; background-color:#565754; font-weight:600; color:white;">My Reports
                </b-button>
                </b-row>
                </b-form-group>
            </div>
        </div>
        </b-container>
        <b-tabs justified content-class="mb-5" style="margin-top:20px;">
            <b-container>
            <b-tab active >
                <template v-slot:title class="">
                    <h5 class="mt-3" style="font-weight: bold; font-family: roboto; font-size:22px; color:#1D1D1D;">UNEA Outcome Reports</h5>
                </template>
                <div class="row mt-3" style="">
                    <div class="col-md-4 align-items-center d-flex justify-content-center" style="background-color:#F4F4F4;">
                        <b-form-group class="col mt-3">
                            <b-row class="">
                            <b-col sm="3" style="text-align:right;" class="mt-1">  
                            <label style="font-weight:600; font-size:14px;">Show</label><br>
                            </b-col>
                            <b-col sm="4" class="align-items-center d-flex justify-content-left">
                            <b-form-select
                                    style="font-weight:600; font-size:14px; border:none; border-radius: unset;"
                                    class=" col-xl-7 ml-1"
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions">
                            </b-form-select>
                            </b-col>
                            <b-col sm="5">
                            </b-col>
                            </b-row>
                        </b-form-group>
                    </div>
                    <div class="col-md-4" style="background-color:#F4F4F4;">
                        <b-form-group class="col mt-3">
                            <b-row class="">
                            <b-col sm="4" style="text-align:right" class="mt-1">
                            <label style="font-weight:600; font-size:14px;">Filter By</label><br>
                            </b-col>
                            <b-col sm="8" class="align-items-center d-flex justify-content-left" style="text-align:left;">
                            <b-form-select style="font-weight:600; border:none; font-size:14px; border-radius: unset;" v-model="filterBy" id="filterBySelect" :options="sortOptions" class=" col-xl-12"></b-form-select>
                            </b-col>
                            </b-row>
                        </b-form-group>
                    </div>
                     <div class="col-md-1" style="text-align:right; color:#565754; font-size:14px;">
                        <b-button class="mt-3" size="sm" @click="filterOutcomes" variant="outline-none" style="font-weight:600; font-size:18px;"><b-icon-search class="h1"></b-icon-search></b-button>
                    </div>
                    <div class="col-md-3" style="background-color:#F4F4F4;">
                        <b-form-group class="col mt-3" style="text-align:left">
                            <b-form-input
                                    v-show="filterBy != 'type'"
                                    style="font-weight:600; font-size:14px; border-radius: unset; border:none;"
                                    v-on:keyup.enter="filterOutcomes"
                                    v-model="filterValue"
                                    type="search"
                                    id="filterInput"
                                    size="sm"
                                    class=""
                                    placeholder="Search by column selected"></b-form-input>

                            <b-form-select 
                                @change="filterOutcomes"
                                v-show="filterBy == 'type'"
                                style="font-weight:600; border:none; font-size:14px; border-radius: unset;" 
                                v-model="filterValue" 
                                id="filterByTypeSelect" 
                                :options="filterTypeOptions" 
                                class=" col-xl-12"></b-form-select>
                        </b-form-group>
                    </div>
            </div>
                <div class="row" style="margin-top:18px;">
                    <b-table class="myTable" bordered="" hover style="background-color:#F4F4F4; border: 2px solid white;" show-empty stacked="md" :items="fetchData" :fields="fields"
                             :sort-by.sync="sortBy" ref="tableOutcomes"
                             :sort-desc.sync="sortDesc" :small="small" :per-page="perPage" :filter="filter"
                             :current-page="currentPage">

                        <template v-slot:cell(success)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.success"/>
                        </template>

                        <template v-slot:cell(outcome.outcome_name)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.outcome.outcome_name"/>
                        </template>

                        <template v-slot:cell(outcome.assembly_id)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.outcome.assembly_id"/>
                        </template>

                        <template v-slot:cell(period.period)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.period.period"/>
                        </template>

                        <template v-slot:cell(outcome.outcome_code)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.outcome.outcome_code"/>
                        </template>

                        <template v-slot:cell(partners)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.partners"/>
                        </template>

                         <template v-slot:cell(type)="data">
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-if="data.item.type==0">Member States Report</span>
                            <span style="font-family:roboto; font-size:17px; font-weight:500;" v-else>Secretariat Report</span>
                        </template>

                        <template v-slot:cell(actions)="row">
                            <router-link size="sm" :to="{name: 'viewreport', params:{id: row.item.id}}" variant="primary"
                                      class="mr-1 mt-1 mb-1" style="font-family:roboto; font-size:17px; font-weight:500;">
                                 
                                View 
                            </router-link>
                        </template>
                    </b-table>
                </div>

                <div v-bind:hidden="loadedData2" id="loadingGif2" style="text-align: center;">
                    <img src="../assets/loading.gif" style="text-align: center; height: 100px;">
                </div>

                <b-container class="mb-4" style="margin-bottom:50px;">

        <div class="col-md-12 mt-3">
            <div class="row justify-content-center">
                <b-pagination style="color:#565754" size="md" :total-rows="totalItems" v-model="currentPage" :per-page="perPage">
                </b-pagination>
            </div>
        </div>
        </b-container>
    </b-tab>

            <b-tab style="">
                <template v-slot:title class="">
                    <h5 class="mt-3" style="font-weight: bold; font-family: roboto; font-size:22px; color:#1D1D1D;">UNEP Programme Performance Reports and UNEP Quarterly Reports</h5>
                </template>


                <div class="row mt-2">
                    <b-table :items="fetchDataPow">
                    </b-table>
                </div> 
                <b-row>
                    <b-col sm="6">
                        <b-table striped :items="fetchDataPow2" :fields="fieldsPow1">
                             <template v-slot:cell(full_title)="data" v-bind:hidden="data.item.title !== `PPR REPORT`">
                                 <div v-bind:hidden="data.item.title !== `PPR REPORT`">
                                <a   :href="data.item.link" target="_BLANK" style="color:#00abf1; text-decoration:none;"><span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.full_title + '\t' + `\t` + `-` + `\t` +data.item.year"/></a>
                                </div>
                            </template>
                        </b-table>
                    </b-col>
                    <b-col sm="6">
                        <b-table striped :items="fetchDataPow3" :fields="fieldsPow3">
                             <template v-slot:cell(full_title)="data" v-bind:hidden="data.item.title !== `PPR REPORT`">
                                 <div v-bind:hidden="data.item.title !== `QUARTERLY REPORT`">
                                <a   :href="data.item.link" target="_BLANK" style="color:#00abf1; text-decoration:none;"><span style="font-family:roboto; font-size:17px; font-weight:500;" v-html="data.item.full_title + '\t' + `\t` + `-` + `\t` +data.item.year"/></a>
                                </div>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>

                <div v-bind:hidden="loadedData" id="loadingGif" style="text-align: center;">
                    <img src="../assets/loading.gif" style="text-align: center; height: 100px;">
                </div>
            </b-tab>
             </b-container>
        </b-tabs>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'Reports',
        components: {},
        created() {
            if(this.$route.query.filterValue) {
                this.filterValue = this.$route.query.filterValue;
                //this.filterBy = this.$route.query.filterBy;
            }
        },
        data() {
            return {
                loadedData: false,
                loadedData2: false,
                loadedData1: false,
                loadedData3: false,
                apiUrl: process.env.VUE_APP_API_PATH,
                items: [],
                color: '',
                filter: null,
                filterValue: '',
                small: false,
                sortBy: '',
                filterBy: 'outcome.outcome_name',
                sortDesc: false,
                sortDirection: 'desc',
                pageOptions: [5, 10, 15],
                filterTypeOptions: [
                    {text: 'Select Report Type', value: ''},
                    {text: 'Member States Report', value: 0},
                    {text: 'Secretariat Report', value: 1},
                ],
                fields: [
                    {
                        key: 'outcome.assembly_id',
                        label: 'Assembly Code',
                        searchable: true,
                        //sortable: true,
                        class:  'tableheader',
                    },
                    {
                        key: 'outcome.outcome_code',
                        label: 'Outcome Code',
                        searchable: true,
                        //sortable: true,
                        class:  'tableheader',
                    },
                    {
                        key: 'outcome.outcome_name',
                        label: 'Outcome Name',
                        searchable: true,
                        //sortable: true,
                        class:  'tableheader',
                    },
                    {
                        key: 'period.period',
                        label: 'Reporting Period',
                        //sortable: true,
                        searchable: true,
                        class:  'tableheader',
                    },
                    {
                        key: 'type',
                        label: 'Report Type',
                        //sortable: true,
                        searchable: true,
                        class:  'tableheader',
                    },
                    {
                        key: 'actions',
                        label: 'Action',
                        thStyle: {width: '100px'},
                        class:  'tableheader',
                    }
                ],
                currentPage: 1,
                perPage: 10,
                totalItems: 0,
                totalItemsPow: [],
                totalItemsPow1: [],
                currentPagePow: 1,
                currentPagePow1: 1,
                perPagePow: 100,
                perPagePow1: 100,
                filterPow: '',
                filterBy: 'outcome.outcome_name',
                filterPow1: '',
                filterByPow: 'id',
                filterByPow1: 'id',
                sortDirectionPow: 'asc',
                sortDirectionPow1: 'asc',
                smallPow: false,
                smallPow1: false,
                sortDescPow: false,
                sortDescPow1: false,
                sortByPow: 'id',
                sortByPow1: 'id',
                filterValuePow: '',
                filterValuePow1: '',
                fieldsPow1: [
                
                    {
                        key: 'full_title',
                        label: 'PROGRAMME PERFORMANCE REPORTS',
                        //sortable: true,
                        searchable: true,
                    },
                ],
                fieldsPow3: [
                
                    {
                        key: 'full_title',
                        label: 'QUARTERLY REPORTS',
                        //sortable: true,
                        searchable: true,
                    },
                ],
            }
        },
        computed: {
            
            sortOptions() {
                // Create an options list from our fields
                return this.fields
                    .filter(f => f.searchable)
                    .map(f => {
                        return {text: f.label, value: f.key}
                    })
            },
            getShowEditDelete() {
                let isadmin = document.getElementById('loggedInUserIsAdmin').value;
                if (isadmin != '1') {
                    return true;
                }

                return false;
            },
            getShowMyReports() {
                let isadmin = document.getElementById('loggedInUserIsAdmin').value;
                let isreporter = document.getElementById('loggedInUserIsReporter').value;
                if (isreporter != '1') {
                    return true;
                }

                return false;
            },
            sortOptionsPow() {
                // Create an options list from our fields
                return this.fieldsPow
                    .filter(f => f.searchable)
                    .map(f => {
                        return {text: f.label, value: f.key}
                    })
            },
             showAdmin() {
                let isadmin = document.getElementById('loggedInUserIsAdmin').value;
                if (isadmin != '1') {
                    return true;
                }

                return false;
            },
        },
        methods: {
            choseColor(m) {
            if((m % 4) == 0){
                return `#B1ADAD`;
            }else if((m % 4) == 1){
                return `#00A2E4`;
            }else if ((m % 4) == 2){
                return `#DDDBDB`;
            }else if((m % 4 == 3)){
            return `#9BC455`;
            }
            },
            filterPowData() {
                this.currentPagePow = 1;
                this.loadedData = false;
                this.$refs.tablePow.refresh();
            },
            fetchDataPow(ctx, callback) {
                let url = this.apiUrl;
                let sortD = this.sortDescPow ? 'asc' : 'desc';
                fetch(url + '/getpowreports?_page=' + `${this.currentPagePow}&_limit=${this.perPagePow}&_filterBy=${this.filterByPow}&_sortBy=${this.sortByPow}&_sortDirection=${sortD}&_filter=${this.filterValuePow}`)
                    .then(res => res.json())
                    .then(res => {
                        this.totalItemsPow = res["data"];
                        this.loadedData = true;
                        callback(res["data"]);
                    })
                return null
            },

            fetchDataPow2(ctx, callback) {
                let url = this.apiUrl;
                let sortD = this.sortDescPow ? 'asc' : 'desc';
                fetch(url + '/getpow2reports?_page=' + `${this.currentPagePow}&_limit=${this.perPagePow}&_filterBy=${this.filterByPow}&_sortBy=${this.sortByPow}&_sortDirection=${sortD}&_filter=${this.filterValuePow}`)
                    .then(res => res.json())
                    .then(res => {
                        this.totalItemsPow1 = res["data"];
                        this.loadedData1 = true;
                        callback(res["data"]);
                    })
                return null
            },

            fetchDataPow3(ctx, callback) {
                let url = this.apiUrl;
                let sortD = this.sortDescPow ? 'asc' : 'desc';
                fetch(url + '/getpow3reports?_page=' + `${this.currentPagePow}&_limit=${this.perPagePow}&_filterBy=${this.filterByPow}&_sortBy=${this.sortByPow}&_sortDirection=${sortD}&_filter=${this.filterValuePow}`)
                    .then(res => res.json())
                    .then(res => {
                        this.totalItemsPow3 = res["data"];
                        this.loadedData3 = true;
                        callback(res["data"]);
                    })
                return null
            },

            filterOutcomes() {
                this.currentPage = 1;
                this.loadedData2 = false;
                this.$refs.tableOutcomes.refresh();
            },
            fetchData(ctx, callback) {
                let url = this.apiUrl;
                let sortD = this.sortDesc ? 'asc' : 'desc'; 
                fetch(url + '/getreports?_page=' + `${this.currentPage}&_filterBy=${this.filterBy}&_limit=${this.perPage}&_sortBy=${this.sortBy}&_sortDirection=${sortD}&_filter=${this.filterValue}`)
                
 

                    .then(res => res.json())
                    .then(res => {
                        this.totalItems = res["totalItems"];
                        this.loadedData2 = true;

                        callback(res["data"]);
                    })
                return null
            }
        }
    }
</script>

<style>
@font-face {

   font-family: Roboto;

   src: url(https://fonts.googleapis.com/css?family=Roboto);
}
.myTable thead {
   background-color: #00A5E5!important;
   color: #FFFFFF;
   font-size: 22px;
   font-weight: lighter;
   vertical-align:  top;
}
.table-bordered th, .table-bordered td {
    border: 2px solid white;
}
.reports{
    margin: auto!important;
}
.nav-tabs {
    border-bottom: 0px solid #dee2e6!important;
}
.nav-tabs .nav-item {
    background-color: #EBEBEB!important;
    margin-bottom: 0px!important;
    text-align: center;
    border-left: 2px solid white!important;
    border-right: 2px solid white!important;
}
    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    border: 4px solid #91C85F!important;
    border-top-left-radius: 0rem!important;
    border-top-right-radius: 0rem!important;
}
.nav-right{
background-color: #d3d3d3!important;
    margin-bottom: 0px!important;
    border-left: 12px solid white!important;
}
.column_wrapper {
  column-count: 1;
}
.page-link {
    position: relative;
    max-height: auto;
    display:grid;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #171717!important;
    background-color:#F4F4F4!important;
    border: 5px solid white!important;
}
.page-item.disabled .page-link {
    color: #6c757d!important;
    pointer-events: none;
    cursor: auto;
    background-color:#F4F4F4!important;
    border-color: white!important;
}
.page-item.active .page-link {
    z-index: 3;
    color: #0062FF!important;
    background-color: #82CAFA!important;
    border-color: white!important;
}
.nav-tabs .nav-link {
     border: none!important; 
}
.btn-block {
    display:inline-block;
    width: 100%!important;
    min-height:56px;
}
.mycol{
    min-height: 170px!important;
}
</style>